/* Good Travel · Presupuesto: las fichas de regiones (Latinoamérica, Europa, Asia…) abren sus países */
(function () {
'use strict';
var root = document.getElementById('gtq');
if (!root || root.dataset.region || root.querySelector('[data-done]')) return;
root.dataset.region = '1';
var tiles = root.querySelector('[data-tiles]');
if (!tiles) return;
function json(id) { try { var el = document.getElementById(id); return el ? JSON.parse(el.textContent) || {} : {}; } catch (e) { return {}; } }
var REG = json('gtq-reg-data'), DEST = json('gtq-dest-data');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

var sheet = document.createElement('div');
sheet.className = 'q-reg';
sheet.hidden = true;
sheet.innerHTML =
  '<div class="q-reg-bg" data-reg-close></div>' +
  '<div class="q-reg-box" role="dialog" aria-modal="true" aria-labelledby="gtq-reg-t">' +
    '<div class="q-reg-head"><div><small data-reg-kick></small><h3 id="gtq-reg-t" data-reg-title></h3></div>' +
    '<button type="button" class="q-reg-x" data-reg-close aria-label="Cerrar">×</button></div>' +
    '<label class="q-reg-find"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
    '<input type="search" autocomplete="off" data-reg-q></label>' +
    '<ul class="q-reg-list" role="list" data-reg-list></ul>' +
    '<p class="q-reg-none" data-reg-none hidden>No está en la lista. <button type="button" data-reg-custom></button></p>' +
  '</div>';
var portal = document.createElement('div');
portal.className = 'gtq gtq-portal';
portal.appendChild(sheet);
document.body.appendChild(portal);
var list = sheet.querySelector('[data-reg-list]'), q = sheet.querySelector('[data-reg-q]');
var actual = null, lastFocus = null;

function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

/* Región que corresponde a una ficha («Resto de Latinoamérica» → latinoamerica, «Europa» → espana-y-europa…) */
function regionDe(nombre) {
  var k = norm(nombre).trim().replace(/^resto de /, '');
  if (!k) return null;
  var hk = k.replace(/\s+/g, '-');
  for (var h in REG) {
    if (h === 'top-destinos' || !REG[h].d || REG[h].d.length < 2) continue;
    if (h === hk || norm(REG[h].t) === k) return h;
  }
  if (k === 'europa' && REG['espana-y-europa']) return 'espana-y-europa';
  return null;
}

function abrir(tile) {
  var h = regionDe(tile.dataset.pick), R = REG[h];
  if (!R || !R.d || !R.d.length) return false;
  actual = tile;
  var esEstados = h === 'estados-unidos';
  var titulo = (R.t || tile.dataset.pick).replace(/^Resto de /i, '');
  sheet.querySelector('[data-reg-kick]').textContent = titulo + ' · ' + R.d.length + (esEstados ? ' estados' : ' destinos');
  sheet.querySelector('[data-reg-title]').textContent = esEstados ? '¿A qué estado quieres ir?' : '¿A qué país quieres ir?';
  q.placeholder = esEstados ? 'Busca un estado…' : 'Busca un país…';
  q.value = '';
  var html = '<li class="q-reg-any"><button type="button" data-reg-any><b>' + (esEstados ? 'Varios estados' : 'Varios países') + '</b><span>o aún no lo sé, que me aconsejen</span></button></li>';
  R.d.slice().sort(function (a, b) { return a.localeCompare(b, 'es'); }).forEach(function (n) {
    var k = DEST[String(n).toLowerCase()] || {};
    html += '<li data-n="' + esc(norm(n)) + '"><button type="button" data-reg-pick="' + esc(n) + '">' +
      (k.img ? '<img src="' + esc(k.img.replace(/width=\d+/, 'width=120')) + '" alt="" loading="lazy" width="44" height="44">' : '<i>' + esc(n.slice(0, 2).toUpperCase()) + '</i>') +
      '<span>' + esc(n) + '</span></button></li>';
  });
  list.innerHTML = html;
  sheet.querySelector('[data-reg-none]').hidden = true;
  lastFocus = document.activeElement;
  sheet.hidden = false;
  document.documentElement.classList.add('q-reg-open');
  requestAnimationFrame(function () { sheet.classList.add('is-on'); });
  setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) q.focus(); else sheet.querySelector('.q-reg-x').focus(); }, reduce ? 0 : 200);
  return true;
}
function cerrar() {
  sheet.classList.remove('is-on');
  document.documentElement.classList.remove('q-reg-open');
  setTimeout(function () { sheet.hidden = true; }, reduce ? 0 : 220);
  if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
}
/* Elige un país usando el mismo camino que el buscador del paso 1 */
function elegir(nombre) {
  cerrar();
  var sq = root.querySelector('[data-q]'), other = root.querySelector('[data-pick-other]');
  if (!sq || !other) return;
  sq.value = nombre;
  sq.dispatchEvent(new Event('input', { bubbles: true }));
  other.click();
  setTimeout(function () { sq.value = ''; sq.dispatchEvent(new Event('input', { bubbles: true })); }, 30);
}
function toda() {
  var t = actual; cerrar();
  if (!t) return;
  t.dataset.skip = '1'; t.click(); delete t.dataset.skip;
}

/* Paso 1: unos destinos al azar arriba y los continentes (con su número de países) debajo */
function barajar(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), x = a[i]; a[i] = a[j]; a[j] = x; } return a; }
function cabecera(txt) { var li = document.createElement('li'); li.className = 'q-tiles-h'; li.setAttribute('role', 'presentation'); li.textContent = txt; return li; }
(function montar() {
  var conts = Array.prototype.filter.call(tiles.querySelectorAll('[data-pick]'), function (b) { return regionDe(b.dataset.pick); });
  conts.forEach(function (b) {
    var h = regionDe(b.dataset.pick), R = REG[h], tag = b.querySelector('.q-tag');
    var txt = R.d.length + (h === 'estados-unidos' ? ' estados' : ' países');
    if (tag) tag.textContent = txt;
    b.setAttribute('aria-label', b.dataset.pick + ', ' + txt);
  });
  var vistos = {}, latam = [], resto = [];
  Object.keys(REG).forEach(function (h) {
    if (h === 'top-destinos' || h === 'estados-unidos') return; /* solo países */
    (REG[h].d || []).forEach(function (n) {
      var k = DEST[String(n).toLowerCase()];
      if (!k || !k.img || vistos[n]) return;
      vistos[n] = 1;
      (h === 'latinoamerica' ? latam : resto).push(k);
    });
  });
  var picks = barajar(barajar(latam).slice(0, 3).concat(barajar(resto).slice(0, 3)));
  var first = tiles.firstElementChild;
  if (!picks.length || !first) return;
  var go = (tiles.querySelector('.q-go') || {}).innerHTML || '→';
  tiles.insertBefore(cabecera('Ideas para tu próximo viaje'), first);
  picks.forEach(function (k) {
    var li = document.createElement('li');
    li.dataset.name = String(k.n).toLowerCase();
    var code = String((k.a && k.a[0] && k.a[0][0]) || k.c || k.n.slice(0, 3)).toUpperCase();
    li.innerHTML = '<button type="button" class="q-tile" aria-pressed="false" data-pick="' + esc(k.n) + '" data-code="' + esc(code) + '" data-img="' + esc(k.img) + '">' +
      '<img src="' + esc(k.img.replace(/width=\d+/, 'width=600')) + '" alt="" loading="lazy">' +
      '<span class="q-tag q-mono">' + esc(code) + '</span><span class="q-name">' + esc(k.n) + '<span class="q-go">' + go + '</span></span></button>';
    tiles.insertBefore(li, first);
  });
  if (conts.length) tiles.insertBefore(cabecera('O elige un continente y verás todos sus países'), first);
  var sq = root.querySelector('[data-q]');
  if (sq) sq.addEventListener('input', function () {
    var busca = !!sq.value.trim();
    Array.prototype.forEach.call(tiles.querySelectorAll('.q-tiles-h'), function (h) { h.hidden = busca; });
  });
})();

/* Las fichas de región abren la lista en lugar de pasar directamente al paso 2 */
tiles.addEventListener('click', function (e) {
  var t = e.target.closest('[data-pick]');
  if (!t || t.dataset.skip || !regionDe(t.dataset.pick)) return;
  if (abrir(t)) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);

sheet.addEventListener('click', function (e) {
  if (e.target.closest('[data-reg-close]')) { cerrar(); return; }
  var p = e.target.closest('[data-reg-pick]'); if (p) { elegir(p.dataset.regPick); return; }
  if (e.target.closest('[data-reg-any]')) { toda(); return; }
  if (e.target.closest('[data-reg-custom]')) { elegir(q.value.trim()); }
});
q.addEventListener('input', function () {
  var t = norm(q.value.trim()), vis = 0;
  Array.prototype.forEach.call(list.querySelectorAll('li[data-n]'), function (li) { var s = !t || li.dataset.n.indexOf(t) > -1; li.hidden = !s; if (s) vis++; });
  var none = sheet.querySelector('[data-reg-none]');
  none.hidden = !t || vis > 0;
  sheet.querySelector('[data-reg-custom]').textContent = 'Quiero ir a «' + q.value.trim() + '» →';
});
q.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  e.preventDefault();
  var v = list.querySelectorAll('li[data-n]:not([hidden]) button');
  if (v.length === 1) v[0].click(); else if (q.value.trim() && !v.length) elegir(q.value.trim());
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) cerrar(); });

/* Si llega desde el menú con una región (?destino=Asia), se abre su lista */
var pre = new URLSearchParams(location.search).get('destino');
if (pre) {
  var t = Array.prototype.filter.call(tiles.querySelectorAll('[data-pick]'), function (b) { return regionDe(b.dataset.pick) && (norm(b.dataset.pick) === norm(pre) || regionDe(b.dataset.pick) === regionDe(pre)); })[0];
  if (t) {
    var back = root.querySelector('[data-back]');
    setTimeout(function () { if (back && !back.hidden) back.click(); abrir(t); }, 80);
  }
}
})();
